
import Upload from "../../common/upload/upload.vue";
export const mixin = {
  data: function () {
    return {
      visible: true,
      syncing: false,
      count: 1,
      uploadConfig: {
        limit: 5,
        limitSize: 3145728,
        // listType: 'picture-card',
        readOnly: false,
        xtype: 'invoice',
        accept: '.jpg,.jpeg,.png,.pdf,.JPEG,.JPG,.PNG,.PDF',
        acceptMsg: '只能传图片/pdf格式文件'
      }
    }
  },
  components: {
    Upload
  },
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  computed:{
    btnTitle(){
      if(this.syncing){
        return '正在识别第'+this.count+'张';
      }else{
        return '开始识别';
      }
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    handlerFileUploadSuccess(file){

    },
    handlerFileLoaded(fileList){

    },
    handlerDialogClosed() {
      this.$emit('handlerDialogClosed');
    },
    submit(){
      let fileList = null;
      let uploading = this.$refs['uploading_invoice'];
      if (uploading) {
        if (uploading.length > 0) {
          uploading = uploading[0];
        }
        fileList = uploading.getFilesArr();
        if(fileList.length === 0){
          this.util.warn('请先上传图片！');
          return;
        }
      }else{
        this.util.warn('上传组件不存在！');
        return;
      }
      this.ocr(fileList,1);
    },
    ocr(fileList,index){
      let mappings = this.config.mappings;
      let fileColumnName = this.config.fileColumnName;
      let childrenMappings = this.config.childrenMappings;
      this.count = index;
      let f = fileList[index-1];
      this.syncing = true;
      this.util.restPost('/api_v1/ocr/invoice', f.data, res => {
        // console.log('----res----',res);
        if(res.status === 200 && res.data){
          let invoice = res.data;
          let children = invoice['children'];
          let row = {};
          let file = f.data;
          file.raw = f.raw;
          f.data['xtype'] = fileColumnName;
          row[fileColumnName + 'filesList'] = [file];
          row[fileColumnName] = f.id;
          let uniqueColumnName = [];
          for(let key in mappings){
            let desKey = mappings[key];
            row[key] = res.data[desKey];
            if(desKey === 'invoiceCode'){
              uniqueColumnName.push(key);
            }else if(desKey === 'invoiceNum'){
              uniqueColumnName.push(key);
            }
          }
          if(uniqueColumnName.length !== 2){
            uniqueColumnName = ['invoiceCode','invoiceNum'];
          }
          // 组织明细
          if(children && childrenMappings){
            let newChildren = [];
            children.forEach(c=>{
              let item = {}
              for(let key in childrenMappings){
                let desKey = childrenMappings[key];
                item[key] = c[desKey];
              }
              newChildren.push(item);
            });
            row.children = newChildren;
          }
          // console.log('-----handlerOcrSuccess---11----',row,uniqueColumnName)
          this.util.success('第'+index+'张识别成功');
          this.$emit('handlerOcrSuccess',row,uniqueColumnName);
        }else{
          this.util.warn('第'+index+'张无法识别！');
        }
        this.syncing = false;
        // 判断是否有下一个
        if(fileList.length>index){
          this.ocr(fileList,++index);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ocr-invoice/index.js